import { googleApiKey } from "utils/env";

export const mapOptions = {
  id: "google-map-script",
  googleMapsApiKey: googleApiKey,
  libraries: ["places"] as "places"[],
};
